import React, { useCallback } from 'react';

import ActionsCancelNormalXsmall from '@strava/icons/ActionsCancelNormalXsmall';

import { useMRE } from '../../hooks/useMRE';
import { useMREState } from '../../hooks/useMREState';

import styles from './FlyoverCancel.module.scss';

export const FlyoverCancel = () => {
  const { t, track } = useMRE();
  const { setIsFlyoverInProgress, resetCameraAndContent } = useMREState();

  const handleCancelFlyover = useCallback(() => {
    // Reset camera and content to original state
    resetCameraAndContent();

    setIsFlyoverInProgress(false);

    track({
      action: 'cancel',
      element: 'flyover'
    });
  }, [track, setIsFlyoverInProgress, resetCameraAndContent]);

  return (
    <button
      title={t('mre.flyover.exit')}
      className={styles.flyoverCancel}
      onClick={handleCancelFlyover}
      data-testid="mre-exit-flyover-button"
    >
      <ActionsCancelNormalXsmall />
    </button>
  );
};
